<template>
  <div class="verify">
    <div class="title">
      <router-link :to="{name:'Home'}">首页</router-link>
      <a>&emsp;<span class="Breadcrumb"><i
        class="el-icon-arrow-right "></i></span>&emsp;{{ type === '1' ? '客服验证' : '账户验证' }}</a>
    </div>
    <div class="customerServiceInquiry">
      <div class="label">
        <span></span>
        {{ type === '1' ? '客服查询' : '官方收款账户查询' }}
      </div>
      <div class="input">
        <el-input :placeholder="type === '1' ?'请输入客服号':'请输入官方收款账户查询'" v-model.trim="num" class="verifyInput">
          <el-button slot="append" @click="search(num)">
            查询
          </el-button>
        </el-input>
      </div>
    </div>
    <div class="body">
      <div class="label">
        <span></span>
        {{ type === '1' ? '如何识别企业客服真伪（科普贴）' : '游严选官方收款账户（科普贴）' }}
      </div>
      <div class="info">
        <img :src="type === '1' ? 'https://images.pxb7.com/img/kefuyanzheng_pc.jpg':'https://images.pxb7.com/img/zhanghuyanzheng_pc.jpg'" alt="">
      </div>
    </div>
    <el-dialog
      :visible.sync="resultShow"
      :width="`300px`"
      top="30vh"
      :show-close="false"
      center
      custom-class="tipDialogClass"
      v-if="type === '1'"
    >
      <div id="tipDialogClass1">
        <div class="resImg">
          <img :src="isSafe?require('@/assets/image/Verify/success.png'):require('@/assets/image/Verify/fail.png')"
               alt="">
          <p>{{ isSafe ? '验证正确' : '验证错误' }}</p>
          <p>输入号码<span>{{ isSafe ? '是' : '非' }}</span>游严选官方客服号</p>
        </div>
        <img class="close" src="@/assets/image/AccountDeal/close.png" alt="" @click="resultShow = false">
      </div>

    </el-dialog>
    <el-dialog
      :visible.sync="resultShow"
      :width="`483px`"
      top="20vh"
      :show-close="false"
      center
      custom-class="tipDialogClass"
      v-else-if="type === '2'"
    >
      <div id="tipDialogClass2">
        <div class="resImg" :class="isSafe?'safe':'danger'">
          <img :src="isSafe?require('@/assets/image/Verify/success.png'):require('@/assets/image/Verify/fail.png')"
               alt="">
          <div class="head_tip">
            <div>{{ isSafe ? '验证正确' : '验证错误' }}</div>
            <div>此查询账户<span>{{ isSafe ? '为' : '非' }}</span>游严选官方收款账户</div>
          </div>
<!--          <div class="head_tip_box" v-if="isSafe">
            <div class="head_tip_box_item">
              <div class="label">验证账户：</div>
              <div class="text">{{ resultObj.customer_number }}</div>
            </div>
            <div class="head_tip_box_item">
              <div class="label">收款人：</div>
              <div class="text">{{ resultObj.customer_name }}</div>
            </div>
          </div>-->
          <div class="head_tip_box" v-if="!isSafe">
            警惕诈骗，游严选官方收款账户以下方为准
          </div>
        </div>
        <div class="payAccBox">
          <div class="payAccBox-head">
            <img src="../../../assets/image/Verify/payAcc.png" alt="">
          </div>
          <div class="payAccCard" v-if="wechat.length>0">
            <div class="payAccCard-head">
              <div class="payAccCard-head-ico">
                <img src="@/assets/image/PersonalCenter/FinancialCenter/WeChatLogo.png" alt="">
              </div>
              <div class="acc_no" style=" margin: 0 128px 0 0;">微信账户</div>
              <div class="acc_name">收款人</div>
            </div>
            <div class="payAccList">
              <div class="payAccItem" v-for="(item,index) in wechat" :key="index">
                <div class="acc_no">{{item.customer_number}}</div>
                <div class="acc_name">{{item.customer_name}}</div>
              </div>
            </div>
          </div>
          <div class="payAccCard" v-if="bank.length>0">
            <div class="payAccCard-head">
              <div class="payAccCard-head-ico">
                <img src="@/assets/image/PersonalCenter/FinancialCenter/BankLogo.png" alt="">
              </div>
              <div class="acc_no">银行卡账户</div>
              <div class="acc_name">收款人</div>
            </div>
            <div class="payAccList">
              <div class="payAccItem" v-for="(item,index) in bank" :key="index">
                <div class="acc_no">{{item.customer_number}}</div>
                <div class="acc_name">{{item.customer_name}}</div>
              </div>
            </div>
          </div>
          <div class="payAccCard" v-if="alipay.length>0">
            <div class="payAccCard-head">
              <div class="payAccCard-head-ico">
                <img src="@/assets/image/PersonalCenter/FinancialCenter/AlipayLogo.png" alt="">
              </div>
              <div class="acc_no">支付宝账户</div>
              <div class="acc_name">收款人</div>
            </div>
            <div class="payAccList">
              <div class="payAccItem" v-for="(item,index) in alipay" :key="index">
                <div class="acc_no">{{item.customer_number}}</div>
                <div class="acc_name">{{item.customer_name}}</div>
              </div>
            </div>
          </div>

        </div>
        <img class="close" src="@/assets/image/AccountDeal/close.png" alt="" @click="resultShow = false">
      </div>

    </el-dialog>
  </div>
</template>
<script>
import {apiCusVerify, apiCusPayVerify,apiCusPayaccList} from '@/request/API';

export default {
  name: '',
  props: {},
  components: {},
  data() {
    return {
      num: '',
      isSafe: false,
      alipay: [],
      wechat: [],
      bank:[],
      //查询结果弹窗
      resultShow: false,
      // 查看官方账号弹窗
      resultShow2: false,
      // 客服验证1 账户验证2
      type: '1',
      //查询结果
      resultObj:{}
    }
  },
  methods: {
    /**
     * 客服验证查询
     * @param number
     */
    custVerify(number) {
      if (!number) {
        this.$message({
          type: "error",
          message: '请输入客服号查询',
          center: true
        })
        return
      }
      apiCusVerify({
        number: number
      }).then(res => {
        this.isSafe = true
      }).catch(err => {
        this.isSafe = false
      }).finally(() => {
        this.resultShow = true
      })
    },
    /**
     * 查看官方账号弹窗
     */
    lookOfficial() {
      this.resultShow2 = true
      this.resultShow = false
    },
    /**
     * 查询
     * @param num
     */
    search(num) {
      if (this.type === '1') {
        this.custVerify(num)
      } else if (this.type === '2') {
        this.cusPayVerify(num)
      }
    },

    /**
     * 官方收款账户查询
     * @param num
     */
    cusPayVerify(num) {
      apiCusPayVerify({
        number: num
      }).then(res => {
        this.resultObj = res.data
        this.isSafe = true
      }).catch(err => {
        this.isSafe = false
      }).finally(() => {
        this.resultShow = true
      })
    },


    /**
     * 官方支付账户配置列表
     */
    getCusPayaccList(){
      apiCusPayaccList({

      }).then(res=>{
        for (let datum of res.data) {
          if (datum.type.indexOf('5')>-1) {
            this.alipay.push(datum)
          }else if (datum.type.indexOf('6')>-1) {
            this.wechat.push(datum)
          }else if (datum.type.indexOf('7')>-1) {
            this.bank.push(datum)
          }
        }
      })
    }
  },
  mounted() {
    this.getCusPayaccList()
  },
  created() {
    this.type = this.$route.query.type
  },
  watch: {},
  computed: {}
}
</script>

<style lang='less' scoped>
.verify {
  width: 1200px;

  .title {
    height: 80px;
    display: flex;
    align-items: center;
    margin-left: 5px;

    a {
      font-size: 12px;
    }

    a:first-of-type {
      font-size: 16px;
      font-family: PingFangSC-Thin, PingFang SC;
      font-weight: 300;
      color: #8F8F8F;
    }

    a:last-of-type {
      font-size: 16px;
      font-family: PingFangSC-Light, PingFang SC;
      font-weight: 400;
      color: var(--primary, #FF5A1F);
      cursor: pointer;
    }
  }

  .customerServiceInquiry {
    border-radius: 4px;
    background: #FFFFFF;
    padding: 39px 0 34px 126px;
    margin: 0 0 18px;
    display: flex;
    align-items: center;

    .label {
      font-size: 24px;
      font-family: PingFang SC, PingFang SC-Semibold;
      font-weight: 600;
      color: #1A1D24;
      display: flex;
      align-items: center;
      margin: 0 16px 0 0;

      span {
        width: 6px;
        height: 23px;
        background: var(--bg-dark, #1A1D24);
        display: inline-block;
        margin: 0 17px 0 0;
      }
    }

    .input {
      .verifyInput {
        display: flex;
        align-items: center;

        /deep/ .el-input__inner {
          width: 339px;
          height: 52px;
          line-height: 52px;
          border: 1.5px solid #8997a7;
          border-radius: 4px 0 0 4px;
          font-size: 20px;
          font-family: PingFang SC, PingFang SC-Regular;
          font-weight: 400;
        }

        /deep/ .el-input__inner:focus {
          border-color: var(--primary, #FF5A1F);
          box-shadow: none;
        }

        /deep/ .el-input__inner::-webkit-input-placeholder {
          font-size: 20px;
          font-family: PingFang SC, PingFang SC-Regular;
          font-weight: 400;
          color: #aeb6bf;
        }

        /deep/ .el-input-group__append {
          width: 93px;
          height: 52px;
          line-height: 52px;
          background: var(--primary, #FF5A1F);
          border-radius: 0px 4px 4px 0px;
          padding: 0px;
          font-size: 24px;
          font-family: PingFang SC, PingFang SC-Regular;
          font-weight: 400;
          color: #ffffff;
        }

        /deep/ .el-button {
          display: flex;
          align-items: center;
          padding: 0px;
          line-height: 52px;
          margin: auto;
        }

      }
    }
  }

  .body {
    padding: 63px 0 62px 120px;
    border-radius: 4px;
    background-color: #FFFFFF;

    .label {
      font-size: 24px;
      font-family: PingFang SC, PingFang SC-Semibold;
      font-weight: 600;
      color: #1A1D24;
      display: flex;
      align-items: center;
      margin: 0 16px 25px 5px;

      span {
        width: 6px;
        height: 23px;
        background: var(--bg-dark, #1A1D24);
        display: inline-block;
        margin: 0 17px 0 0;
      }
    }

    .info {
      img{
        width: 960px;
      }
    }
  }


  /deep/ .el-dialog__header, /deep/ .el-dialog__body {
    padding: 0 !important;

  }

  /deep/ .tipDialog {
    border-radius: 4px;

    #tipDialog {
      position: relative;
      padding: 16px 20px 15px !important;

      .result {
        width: 100%;
        padding: 0 0 10px;

        .resultTitle {
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 20px;
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          color: #000000;
          line-height: 29px;
          margin: 0 0 5px;
        }

        .resultText {
          text-align: center;
          font-size: 14px;
          font-family: PingFang SC, PingFang SC-Regular;
          font-weight: 400;
          color: #F0EDE8;
        }
      }

      .alipayList {
        background: url('../../../assets/image/Verify/alipayBg.png') no-repeat;
        background-size: contain;
      }

      .wechatList {
        background: url('../../../assets/image/Verify/wechatBg.png') no-repeat;
        background-size: contain;
      }

      .alipayList, .wechatList {
        flex: 1;
        border: 1px solid #F0EDE8;
        border-radius: 4px;
        padding: 20px 0 0 50px;
        margin: 0 5px 10px;

        .listTitle {
          display: flex;
          align-items: center;
          font-size: 14px;
          font-family: PingFang SC, PingFang SC-Medium;
          font-weight: 500;
          color: #5b5b5b;
          margin: 0 0 20px;

          img:nth-child(1) {
            width: 24px;
            height: 24px;
            margin: 0 10px 0 0;
          }

          img:nth-child(2) {
            height: 24px;
            margin-right: 15px;
          }
        }

        .item {
          margin: 0 0 20px;

          div {
            font-size: 14px;
            font-family: PingFang SC, PingFang SC-Regular;
            font-weight: 400;
            color: #5b5b5b;
            line-height: 16px;
            display: flex;
            align-items: center;
            margin: 0 0 5px;

            span {
              width: 56px;
              display: inline-block;
              margin: 5px 15px 0 0;
            }
          }
        }
      }


      .close {
        position: absolute;
        width: 30px;
        height: 30px;
        bottom: -40px;
        left: calc(50% - 15px);
        cursor: pointer;
      }
    }
  }

  /deep/ .tipDialogClass {
    border-radius: 4px;

    #tipDialogClass1 {

      padding: 57px 0 57px;
      text-align: center;

      .resImg {
        img {
          width: 71px;
          height: 71px;
        }

        p:nth-child(2) {
          margin-top: 15px;
          font-size: 22px;
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 700;
          color: #000000;
          line-height: 26px;
        }

        p:nth-child(3) {
          font-size: 18px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #898989;
          line-height: 21px;
        }

        .divider {
          margin: 35px auto;
          width: 257px;
        }

        .el-button--text {
          font-size: 20px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #5FBCC2;
          line-height: 23px;

          .rightArrow {
            font-size: 22px;
          }
        }
      }

      .close {
        position: absolute;
        width: 30px;
        height: 30px;
        bottom: -40px;
        left: calc(50% - 15px);
        cursor: pointer;
      }
    }

    #tipDialogClass2 {

      padding: 0 0 5px;
      text-align: center;
      border-radius: 4px;

      .resImg {
        border-radius: 4px 4px 0 0 ;
        padding: 24px 0 0;
        img {
          width: 71px;
          height: 71px;
        }

        .head_tip {
          div:nth-of-type(1) {
            margin-top: 10px;
            font-size: 28px;
            font-family: PingFang SC-Semibold, PingFang SC;
            font-weight: 600;
            line-height: 33px;
          }

          div:nth-of-type(2) {
            margin-top: 2px;
            font-size: 18px;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            line-height: 21px;
          }
        }

        .head_tip_box {
          margin: 15px auto 0;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          width: 460px;
          min-height: 30px;
          border-radius: 4px 4px 4px 4px;
          opacity: 1;
          font-size: 14px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;

          .head_tip_box_item {
            display: flex;
            align-items: center;
            font-size: 14px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            line-height: 16px;
            padding: 5px 0;

            > .label {
              flex-shrink: 0;
              width: 77px;
            }
          }
        }
      }

      .safe {
        background: linear-gradient(180deg, #EFF9F5 0%, #FFFFFF 71%, #FFFFFF 100%);
        .head_tip {
          color: #43C898;
        }

        .head_tip_box {
          background: #F8FEFC;
          border: 1px solid #C8E4DA;
        }
      }

      .danger {
        background: linear-gradient(180deg, #F9EFEF 0%, #FFFFFF 71%, #FFFFFF 100%);
        .head_tip {
          color: #E96060;
        }

        .head_tip_box {
          background: #FEF8F8;
          border: 1px solid #E4C8C8;
        }
      }

      .payAccBox {
        margin: 20px 11px 0 12px;
        border-top: 1px solid #F7F5F2;

        .payAccBox-head {
          margin: 0 0 11px;
        }

        .payAccCard {
          margin: 0 0 20px;
          .payAccCard-head {
            margin: 0 0 5px;
            height: 30px;
            display: flex;
            align-items: center;
            font-size: 14px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            line-height: 16px;
            color: #D8D2CA;
            background: #f4f7ff;

            .payAccCard-head-ico {
              margin: 0 10px 0 8px;

              img {
                width: 20px;
                height: 20px;
              }
            }

            .acc_no {
              margin: 0 114px 0 0;

            }

          }

          .payAccList {
            max-height: 100px;
            overflow: auto;
            .payAccItem {
              display: flex;
              align-items: center;
              text-align: left;
              padding: 5px 0;
              border-bottom: 1px solid #F2F2F2;

              div {
                width: 50%;
              }
              > div:nth-of-type(1) {
                width: calc(50% - 16px);
                margin: 0 8px;
              }
            }
          }
        }
      }

    }

    .close {
      position: absolute;
      width: 33px;
      height: 33px;
      bottom: -40px;
      left: calc(50% - 15px);
      cursor: pointer;
    }
  }
}
</style>
